import React from "react";
import { useSelectCircleStore } from "../../stores/StoreContext";
import { PlayerToPayOld } from "../playerToPay/PlayerToPayOld";

type props = {};

export const SelectPlayersToPayOld: React.FC<props> = () => {
  const selectCircleStore = useSelectCircleStore();
  return (
    <div>
      {selectCircleStore
        .adjustAndGetSelectedPlayersList()
        .map((player, index) => (
          <PlayerToPayOld key={player.userId} player={player} index={index} />
        ))}
    </div>
  );
};
